import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ErrorPage from "./pages/ErrorPage/ErrorPage";
import AboutMePage from "./pages/AboutMePage/AboutMePage";
import HomePage from "./pages/HomePage/HomePage";
import ExperiencesPage from "./pages/ExperiencesPage/ExperiencesPage";
import ContactPage from "./pages/ContactPage/ContactPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      { element: <AboutMePage />, path: "about" },
      { element: <HomePage />, path: "home" },
      { element: <ExperiencesPage />, path: "experiences" },
      { element: <ContactPage />, path: "contact" },
    ],
  },
]);
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

